import './RechargePowerInfo.css';
import { Props } from './interfaces';
import { useRechargePowerInfo } from './useRechargePowerInfo';

const RechargePowerInfo = ({
  isModDark = false,
  isStopTransaction = false,
  time,
  conectorStatus,
  priceProfile,
}: Props) => {
  const { showArticles, setShowArticles, renderInfoItems, formatCurrency } =
    useRechargePowerInfo(conectorStatus);

  //console.log("orderItemsRecipe", orderItemsRecipe);

  const isFreeCharge: boolean =
    priceProfile !== undefined
      ? priceProfile.priceProfilePeriodFreeCharge
      : true;
  //console.log("priceData:", conectorStatus);
  return (
    <>
      {!isModDark && (
        <div className='estimated-info-section-container'>
          <div className='charge-info-value-time-container'>
            <div className='estimated-time-box'>
              <div
                className={`estimated-value-display ${
                  isModDark ? 'darkMod' : ''
                }`}
              >
                {time ? time : '00:00:00'}
              </div>
            </div>
          </div>
        </div>
      )}

      <div className='estimated-info-section'>
        <div className='estimated-info-section__row'>
          <div className='estimated-info-section__column'>
            <span className='estimated-info-section__text highlighted-text'>
              {isStopTransaction ? 'Valor Total' : 'Valor estimado'}
            </span>
            <span className='estimated-info-section__amount'>
              {formatCurrency(Number(conectorStatus?.amount || 0))}
            </span>
          </div>
        </div>
        <hr className='estimated-info-section__divider' />
        {isFreeCharge ? (
          <h4
            className={`estimated-value-free-recharge ${
              isModDark ? 'darkMod' : ''
            }
          `}
          >
            Recarga gratuita!{' '}
          </h4>
        ) : (
          conectorStatus?.transaction?.order?.orderItems && (
            <>
              <div
                className={`estimated-info-section__articles ${
                  showArticles ? 'open' : ''
                }`}
              >
                {renderInfoItems()}
              </div>
              <div className='estimated-info-section__toggle'>
                <span
                  className='estimated-info-section__toggle-text estimated-info-section__toggle-text--clickable'
                  onClick={() => setShowArticles(!showArticles)}
                >
                  {showArticles
                    ? 'Ver menos informações'
                    : 'Ver mais informações'}
                </span>
              </div>
            </>
          )
        )}
      </div>
    </>
  );
};

export default RechargePowerInfo;
